<template>
  <div class="home">
    <Head></Head>

    <div class="banner">
      <ul class="list">
        <li class="item" v-for="(item,index) in banners"  :key="item" :style="'backgroundImage:url('+item+')'" :class="{'cur':index == active}"></li>
      </ul>
      <div class="tips">
        <div class="tip" v-for="(item,index) in banners"  :key="item" :class="{'cur':index == active}" @click="setActive(index)"></div>
      </div>
    </div>

    <div class="wrap">
      <section class="content1">
        <!-- <h2 class="css1a8429752e20234">一颗红心<br/>只为照亮杏林</h2> -->
        <h3>湖南红杏林科技有限公司，诞生于中国长沙，是一个专注于互联网+中医<br/>的综合性大健康服务平台</h3>
        <p>HONG XINGLIN, born in January 2015 in Changsha, China, is a comprehensive large health service platform focusing on Internet + Chinese medicine.</p>
        <h2 class="css1a8429752e20234">致力于</h2>
        <p class="mission">成为中医大健康领域受人尊重的综合性服务平台</p><br/>
        <p class="mission">成为中医大健康领域领导品牌</p>
      </section>

      <section class="content2 clearfix">
        <div class="text">
          <h4 class="css1a8429752e20234">中国湖南省民办在线教育专委会副主任单位</h4>
          <p>汇聚了一批矢志传承中医技术、造福红尘百姓的杏林名家，致力于为中医梦、<br/>健康中国梦贡献力量</p>
        </div>
        <router-link to="/about" class="more">了解更多<img class="arrow_r" src="../assets/arrow_r.png" alt=""></router-link>
      </section>

      <ul class="textList">
        <li class="textItem clearfix" :class="{'hidden':!isIE,'show':show1}">
          <div class="text">
            <p>传承五千年中医国粹</p>
            <h4 class="css1a8429752e20234">中医魂</h4>
          </div>
          <img class="img" src="../assets/himg1.jpg">
          <img class="absolute" src="../assets/m1.png">
        </li>
        <li class="textItem clearfix" :class="{'hidden':!isIE,'show':show2}">
          <img class="img" src="../assets/himg2.jpg">
          <div class="text">
            <p>助力健康中国梦</p>
            <h4 class="css1a8429752e20234">中国梦</h4>
          </div>
          <img class="absolute" src="../assets/m2.png">
        </li>
        <li class="textItem clearfix" :class="{'hidden':!isIE,'show':show3}">
          <div class="text">
            <p>让中医造福于百姓</p>
            <h4 class="css1a8429752e20234">众生缘</h4>
          </div>
          <img class="img" src="../assets/himg3.jpg">
          <img class="absolute" src="../assets/m3.png">
        </li>
      </ul>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import store from '@/store'

import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'

import banner1 from '@/assets/banner1.jpg'
import banner2 from '@/assets/banner2.jpg'

export default {
  name: 'home',
  data(){
    return {
      banners:[
        banner1,
        banner2
      ],
      show1:false,
      show2:false,
      show3:false,
      active:0,
      isIE:false,
      timer:null
    }
  },
  components: {
    Head,
    Foot
  },
  mounted(){
    this.isIE = this.$isIE;
    if(this.banners.length > 1){
      this.timing();
    }
  },
  methods:{
    setActive(index){
      clearInterval(this.timer);
      this.active = index;
      this.timing();
    },
    timing(){
      this.timer = setInterval(()=>{
        if(this.active >= this.banners.length-1){
          this.active = 0;
        }else{
          this.active++;
        }
      },6000)
    }
  },
  computed: {
    scrollTop () {
      return store.state.scrollTop;
    }
  },
  watch:{
    scrollTop:function(value,oldvalue){
      if(value > 600){
        this.show1 = true;
      }
      if(value > 1000){
        this.show2 = true;
      }
      if(value > 1500){
        this.show3 = true;
      }
    }
  }
}
</script>
<style scoped>
.banner{
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
  max-height: 630px;
}
.banner img{
  border: 0;
}
.list{
  transition: 1.5s;
  position: relative;
  padding-bottom: 33%;
}
.item{
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;
  transition: 0.8s;
  opacity: 0;
}
.list .cur{
  opacity: 1;
}
.tips{
  position: absolute;
  bottom: 10px;
  text-align: center;
  width: 100%;
}
.tip{
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 10px;
  display: inline-block;
  margin: 0 10px;
  transition: 0.8s;
}
.tips .cur{
  width: 40px;
  background: #9D2933;
}
.wrap{
  width: 100%;
  max-width: 1165px;
  margin: 0 auto;
}
.wrap section{
  position: relative;
}
.content1{
  padding: 80px 0;
}
.content1 h2{
  font-size: 38px;
  line-height: 55px;
  margin: 80px 0 34px;
}
.content1 h3{
  font-size: 18px;
  line-height: 34px;
}
.content1 p{
  font-size: 18px;
  color: #999999;
  line-height: 34px;
  margin-top: 34px;
  max-width: 850px;
}
.content1 .mission{
  background: #9D2933;
  font-size: 30px;
  padding: 10px 16px;
  color: #fff;
  margin-bottom: 20px;
  display: inline-block;
  margin-top: 0;
}
.content2{
  display: flex;
  padding: 80px 0;
  justify-content: space-between;
  border-top: 1px solid #E6E6E6;
}
.content2 .text{
  max-width: 720px;
  flex: 1;
  float: left;
}
.content2 h4{
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 34px;
}
.content2 .more{
  background: #9D2933;
  width: 200px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  margin-top: 74px;
  float: right;
}
.content2 .more img{
  border: none;
}
.textItem{
  padding: 60px 0;
  display: flex;
  position: relative;
  overflow: visible;
  letter-spacing: 0;
}
.textItem .img{
  max-width: 660px;
  max-height: 400px;
  float: right;
}
.textItem .absolute{
  position: absolute;
  top: 270px;
  left: -280px;
  max-width: 430px;
  opacity: 0.21;
  height: 80px;
}
.textItem:nth-child(2) .absolute{
  opacity: 0.38;
}
.textItem:nth-child(3) .absolute{
  opacity: 0.7;
}
.textItem .text{
  flex: 1;
  float: left;
  padding-top: 40px;
}
.textItem h4{
  width: 42px;
  font-size: 34px;
  line-height: 42px;
  margin-left: 20px;
  display: inline-block;
  vertical-align:top;
}
.textItem p{
  line-height: 24px;
  margin-left: 158px;
  width: 24px;
  display: inline-block;
  vertical-align:top;
  word-break: break-all;
}
.textItem:nth-child(even) .absolute{
  right: -147px;
  left: auto;
  max-width: 440px;
  top: 283px;
}
.textItem:nth-child(even) .img{
  float: left;
}
.textItem:nth-child(even) .text{
  float: right;
}
.arrow_r{
  width: 38px;
  margin-left: 20px;
}
</style>

